import { Column, Row } from 'src/shared/components/Semantic/all'
import { Badge } from 'src/shared/components/ui/badge'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { useOrganizationCurrency } from 'src/shared/hooks/useOrganizationCurrency'
import { Tooltip } from '../ui'
import { ShieldCheck } from 'lucide-react'

export const ProductPriceDisplay = ({
  price,
  moq,
  variant = 'mobile',
}: {
  price: number
  moq: number
  variant?: 'mobile' | 'desktop'
}) => {
  const { t } = useLocalization()
  const currency = useOrganizationCurrency()

  if (variant === 'mobile') {
    return (
      <Column className="gap-1">
        <Row className="items-center gap-2">
          <h4>
            {price?.toLocaleString() || '-'} {currency}
          </h4>

          <Tooltip
            content={
              <div className="text-sm max-w-[200px] p-1">
                {t(
                  'We guarantee the best price for this product. If you find a better price on the same product from a competitor, we will match the price.',
                  'Vi garanterar bästa priset för denna produkt. Om du hittar ett bättre pris på samma produkt hos en konkurrent så matchar vi priset.'
                )}
              </div>
            }
            delayDuration={0}
            side="top"
          >
            <Badge className="cursor-help text-xs">
              <ShieldCheck className="w-3 h-3 mr-1" />
              {t('Price guarantee', 'Prisgaranti')}
            </Badge>
          </Tooltip>
        </Row>

        <p className="text-xs text-foreground/60 italic">
          {t('All prices are without tax.', 'Alla priser är exklusive moms.')}
        </p>
        <p className="text-xs text-foreground/60 italic">
          {t(
            'Print prices will be added to the price.',
            'Tryckpriser tillkommer.'
          )}
        </p>
      </Column>
    )
  }

  return (
    <Column className="gap-1">
      <Row className="items-center gap-4 flex-wrap">
        <h2 className="text-3xl">
          {price?.toLocaleString() || '-'} {currency}
        </h2>
        <Badge className="text-sm">
          {t('MOQ', 'Minsta orderkvantitet')}: {moq}
        </Badge>
      </Row>

      <p className="text-sm text-foreground/60 italic">
        {t('All prices are without tax.', 'Alla priser är exklusive moms.')}
      </p>
      <p className="text-sm text-foreground/60 italic">
        {t(
          'Print prices will be added to the price.',
          'Tryckpriser tillkommer.'
        )}
      </p>
    </Column>
  )
}
